var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",class:[
    _vm.gridTemplateColumns ? 'is-customized' : 'is-repeated-width',
    _vm.noResponsive ? 'is-no-responsive' : ''
  ],style:({
    '--row-columns': _vm.columns,
    '--row-grid-template-columns': _vm.gridTemplateColumns
  })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }